import { DocumentLibraryPopup } from "../shared/doclib/popup/Popup";
import { ReactDocumentLibrary } from "../shared/doclib/popup/PopupWrapper";
import { ReactDocumentPropertiesPopup } from "../shared/doclib/properties/PropsReact";

export const doclib = {
    ReactDocumentLibrary,
    ReactDocumentPropertiesPopup,
    DocumentLibraryPopup
}